
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { HistoryItemType } from '@/features/shipment-history/types';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';
import moment from 'moment';

@Component
export default class ServiceLevel extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;

  private getDisplayCarrierCode = getDisplayCarrierCode;

  get shipDateTime(): string {
    return moment(this.item.shipDateTime).format('YYYY-MM-DD');
  }
}
